var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 4.333V0L14 4.667H9.667a.334.334 0 01-.333-.333zm-.333 1A.334.334 0 018.667 5V0h-7a.334.334 0 00-.333.333v8.333h2.667V7.48c0-.649.344-1.101.931-1.101.235 0 .393.072.609.239l3.807 3.199c.247.185.389.511.389.865 0 .353-.173.685-.467.914l-3.681 3.17c-.244.19-.408.267-.651.267-.59 0-.936-.453-.936-1.101v-1.266H1.335v3c0 .183.15.333.333.333h12c.183 0 .333-.15.333-.333V5.333H9zm-4.333 8.598c0 .099.118.13.196.069l3.79-3.195a.159.159 0 00.065-.124.12.12 0 00-.053-.096L4.856 7.409c-.079-.059-.189-.027-.189.072v1.853h-5.1c-.233 0-.233.163-.233.337v2.074c0 .187.045.256.233.256h5.1v1.931z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImport);
export default __webpack_public_path__ + "static/media/FileImport.e293a6c2f5f5acd52f22ac4d2e7a574c.svg";
export { ForwardRef as ReactComponent };